import moment from "moment";
import "moment-timezone";

export function setMomentTimezone(
  timezone = process.env.REACT_APP_TIMEZONE
): void {
  moment.tz.setDefault(timezone);
}
